// import React from 'react'

// const PremiumCoupons = () => {
//   return (
//     <div>
//       <div className=''>

//       </div>
//     </div>
//   )
// }

// export default PremiumCoupons


import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Ad from '../Coupons/Ad';
import Buffer from '../Coupons/Buffer';
import { SearchContext } from '../SearchContext';

// const cleanBase64 = (str = '') => str.replace(/^:+/, '').trim();

const PremiumCoupons = ({ sortBy }) => {
  const [ads, setAds] = useState([]);
  const [selectedAd, setSelectedAd] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [linkUrl, setLinkUrl] = useState('');

  const { searchTerm } = useContext(SearchContext);
  const getImageSrc = (img) => {
  if (!img) return null;

  // If it's a server file path
  if (img.startsWith('/images')) {
    return `https://api.bakpoket.com${img}`;
  }

  // If it's already full URL
  if (img.startsWith('http')) {
    return img;
  }

  // Otherwise assume base64
  return `data:image/png;base64,${img}`;
};

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/PremiumCoupons/premium-coupons-all')
      .then((res) => {setAds(res.data)
        console.log(res.data)
      })
      .catch((err) => console.error('API error:', err));
  }, []);

  useEffect(() => {
    const userLogin = JSON.parse(localStorage.getItem('userLogin'));
    const merchantLogin = JSON.parse(localStorage.getItem('merchantLogin'));
    setIsUserLoggedIn(!!(userLogin || merchantLogin));
  }, []);

  const handleAdClick = (ad) => {
    setSelectedAd(ad);
    setShowPopup(true);
    setIsFlipped(false);
    setTimeout(() => setIsFlipped(true), 2000);
    setLinkUrl(ad.merchantUrl || '');
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedAd(null);
    setIsFlipped(false);
    setLinkUrl('');
  };

 
  let sortedAds = [...ads];
  if (sortBy === 'az') {
    sortedAds.sort((a, b) => (a.couponName || '').localeCompare(b.couponName || ''));
  } else if (sortBy === 'newest') {
    sortedAds.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  let filteredAds = sortedAds.filter((ad) =>
    (ad.couponName || '').toLowerCase().includes((searchTerm || '').toLowerCase())
  );

  // if (selectedCategory && selectedCategory !== 'All') {
  //   filteredAds = filteredAds.filter((ad) =>
  //     (ad.category || '').toLowerCase() === selectedCategory.toLowerCase()
  //   );
  // }

  const visibleAds = showAll ? filteredAds : filteredAds.slice(0, 4);
  const loading = ads.length === 0;

  const getCouponText = (ad) => ad?.couponCode || 'No Code';

  return (
    <>
    {/* <h3>Ballas</h3> */}
      <AdGrid>
        {visibleAds.map((ad, idx) => (
          <AdCard key={`ad-${ad.slotId ?? idx}`} onClick={() => handleAdClick(ad)}>
            {ad.image ? (
        <img
  src={getImageSrc(ad.image)}
  alt={`Ad Slot ${ad.slotId}`}
/>


            ) : (
              <Para>No Image Available</Para>
            )}
          </AdCard>
        ))}
      </AdGrid>

      {filteredAds.length > 4 && (
        <ShowMoreBtn onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Show Less' : 'Show More'}
        </ShowMoreBtn>
      )}

      {loading ? (
        <Buffer />
      ) : (
        showPopup &&
        selectedAd && (
          <PopupOverlay onClick={closePopup}>
            <PopupContainer onClick={(e) => e.stopPropagation()}>
              <FlipCard className={isFlipped ? 'flipped' : ''}>
                <Front>
                  {selectedAd.coupon?.adPost || selectedAd.image ? (
                    <img
                      src={`data:image/png;base64,${
                        selectedAd.coupon?.adPost || selectedAd.image
                      }`}
                      alt={`Ad ${selectedAd.slotId}`}
                    />
                  ) : (
                    <Para>No Coupon available</Para>
                  )}
                </Front>
                {/* <Back>
                  <CouponCode>
                    {isUserLoggedIn 
                      ? getCouponText(selectedAd).toUpperCase() 
                      : 'Login to get the Coupon'.toUpperCase()}
                  </CouponCode>

                  <Ad className="ad" />
                  {linkUrl ? (
                    <StyledLink 
                    href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                    target="_blank" rel="noopener noreferrer">
                      Visit More Offer
                    </StyledLink>
                  ) : (
                    <NoLinkText>No external offer link available</NoLinkText>
                  )}
                </Back> */}
                <Back>
                  <CouponCode>
                    {isUserLoggedIn 
                      ? getCouponText(selectedAd).toUpperCase() 
                      : 'Login to get the Coupon'.toUpperCase()}
                  </CouponCode>

                  <Ad className="ad" />

                  {isUserLoggedIn ? (
                    linkUrl ? (
                      <StyledLink 
                        href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Visit More Offers
                      </StyledLink>
                    ) : (
                      <NoLinkText>No external site link available</NoLinkText>
                    )
                  ) : null}
                </Back>

              </FlipCard>
              <CloseButton onClick={closePopup}>×</CloseButton>
            </PopupContainer>
          </PopupOverlay>
        )
      )}
    </>
  );
};

export default PremiumCoupons;


const AdGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 20px 110px;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px 60px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
    padding: 10px 16px;
  }
`;

const AdCard = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  padding: 5px;

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const Para = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  text-align: center;
  font-size: 10px;
`;

const ShowMoreBtn = styled.button`
  background-color: #2a4157;
  color: #fff;
  width: 140px;
  padding: 10px 20px;
  margin: 20px auto;
  display: block;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #ef4766;
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  top: 0px;
`;

const PopupContainer = styled.div`
  position: relative;
  width: 300px;
  height: 400px;
  perspective: 1000px;

  @media(max-width:720px){
    width: 200px;
    height: 300px;
  }
  @media(max-width:576px){
    width: 200px;
    height: 300px;
  }
`;

const FlipCard = styled.div`
  width: 100%;
  height: 85%;
  transition: transform 1s;
  transform-style: preserve-3d;
  position: relative;

  &.flipped {
    transform: rotateY(180deg);
  }
`;

const Front = styled.div`
  backface-visibility: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 10px;
  }
`;

const Back = styled.div`
  backface-visibility: hidden;
  transform: rotateY(180deg);
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #2a4157;
  color: white;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 90px 0px 50px 0px;

  .ad {
    position: absolute;
    top: 0px;
  }

  @media(max-width:720px){
    padding: 90px 0px 40px 0px;
  }
`;

const CouponCode = styled.h2`
  font-size: 30px;
  text-align: center;
  padding: 0px;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 15px;
    padding: 10px;
  }
`;

const CloseButton = styled.span`
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 17px;
  font-weight: bold;
  color: white;
  background: #000;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align:center;
`;

const StyledLink = styled.a`
  display: inline-block;
  margin-top: 10px;
  color: #ffcb05;
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    color: #ffd700;
  }
`;

const NoLinkText = styled.div`
  color: #ccc;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
`;

